import React from 'react';
import { connect } from 'react-redux';
import { KeyLicenseTypes } from '../common/keyLicenseTypes';
import { showModalMessage } from '../store/modalsSlice';
import * as temporaryLicenseHist from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { temporaryLicensesSelectors } from '../store/temporaryLicensesSlice';
import TemporaryLicenseHistoryTableHeader from '../components/temporaryLicenseHistoryTableHeader';

import KeyLicenseHistoryDialog from '../components/keyLicenseHistoryDialog';

class TemporaryLicenseHistoryDialog extends KeyLicenseHistoryDialog {
  get LicenseType() {
    return KeyLicenseTypes.OnlineTemporary;
  }

  renderBeforeContent() {
    const objectData = this.props.selectedTemporaryLicense(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <TemporaryLicenseHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }
}

const mapStateToProps = state => ({
  objectState: objectHistorySelectors.temporaryLicenses(state),
  getEditedFields: () => objectHistorySelectors.temporaryLicensesEditedFields(state),
  selectedTemporaryLicense: (id) => temporaryLicensesSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (id) => temporaryLicenseHist.fetchHistory(id, objectHistoryNames.temporaryLicenses),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(TemporaryLicenseHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/temporaryLicenseHistoryDialog.js